export const strippedText = (data): any => {
  return data.replaceAll(/(\n|<([^>]+)>)/gi, '');
};
